export const READ_JOON3_CONFIGS = 'READ_JOON3_CONFIGS';
export const CREATE_JOON3_CONFIG = 'CREATE_JOON3_CONFIG';
export const UPDATE_JOON3_CONFIG = 'UPDATE_JOON3_CONFIG';
export const DELETE_JOON3_CONFIG = 'DELETE_JOON3_CONFIG';

export const readJoon3ConfigsAction = (
  // eslint-disable-next-line no-shadow
  joon3Configs,
  queryId = 'default',
) => ({
  type: READ_JOON3_CONFIGS,
  payload: {
    joon3Configs,
    queryId,
  },
});

export const createJoon3ConfigAction = (joon3Config, queryId = 'default') => ({
  type: CREATE_JOON3_CONFIG,
  payload: {
    joon3Config,
    queryId,
  },
});

export const updateJoon3ConfigAction = (joon3Config, queryId = 'default') => ({
  type: UPDATE_JOON3_CONFIG,
  payload: {
    joon3Config,
    queryId,
  },
});

export const deleteJoon3ConfigAction = (
  joon3ConfigId,
  queryId = 'default',
) => ({
  type: DELETE_JOON3_CONFIG,
  payload: {
    joon3ConfigId,
    queryId,
  },
});

const initialJoon3Configs = { default: {} };

export function joon3Configs(state = initialJoon3Configs, action) {
  switch (action.type) {
    case READ_JOON3_CONFIGS: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.joon3Configs.forEach((p) => {
        newState[action.payload.queryId][p._id] = p;
      });
      return newState;
    }
    case CREATE_JOON3_CONFIG:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.joon3Config._id]: action.payload.joon3Config,
        },
      };
    case UPDATE_JOON3_CONFIG: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][action.payload.joon3Config._id]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.joon3Config._id]: {
            ...current,
            ...action.payload.joon3Config,
          },
        },
      };
    }
    case DELETE_JOON3_CONFIG: {
      const { joon3ConfigId } = action.payload;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [joon3ConfigId]: undefined,
        },
      };
    }
    default:
      return state;
  }
}
